export default __webpack_public_path__ + "static/Digital_Spec_100x700_Artvizit.co-def35c3c449fa410ef718aa0549ea3d6.jpg";